<template>
    <div class="col-md-6 col-lg-4">
        <div class="card card-event">
            <!-- grafiki wycinane do wymiaru 560*382 px -->
            <a :href="event.url"><!-- link do strony wydarzenia -->
                <img v-bind:src="event.smallImage" class="card-img-top" :alt="event.name">
            </a>

            <div class="card-body">
                <div class="event-tags">
                    <div class="btn btn-primary btn-not-active m-1" v-html="getDate(event, withYear)"></div>

                    <div class="btn btn-primary btn-not-active m-1" v-html="event.textStartDate"></div>
                </div>

                <h5 class="card-title">
                    <a :href="event.url" :class="color" v-html="event.name">
                    </a>
                </h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['asset_path', 'event', 'withYear', 'color'],

    methods: {
        getAssetPath(path) {
            return this.asset_path + '/' + path;
        },
        getDate(eventable, withYear = false) {
            var date = '';
            if(withYear) {
                date = eventable.niceDateYear;
                if(eventable.endNiceDateYear) {
                    date += ' - ' + eventable.endNiceDateYear;
                }
            } else {
                date = eventable.niceDate;

                if(eventable.endNiceDate) {
                    date += ' - ' + eventable.endNiceDate;
                }
            }

            return date;
        }
    },
    data() {
        return {
            value: ''
        };
    },
}
</script>
